import HamburgerIcon from '../../../assets/images/icons/hamburger-menu-icon.svg?react'
import PrisyncLogo from '../../../assets/images/icons/prisync-logo.svg?react'

function HamburgerMenu({ toggleMenu }: { toggleMenu: () => void }) {
  return (
    <div className="flex flex-row justify-between w-full lg:hidden border-b-2 border-solid border-gray-100">
      <div className="p-4">
        <PrisyncLogo />
      </div>
      <button
        className="flex flex-col items-center justify-center p-4"
        onClick={toggleMenu}
      >
        <HamburgerIcon />
      </button>
    </div>
  )
}

export default HamburgerMenu
